<template>
  <div class="foot">
    <div class="foot-all" :style="getBjtp1('soldbj.png')">
      <div style="display: flex; width: 100%; height: auto">
        <div class="foot-left">
          <h1>立即加入itall，抢占科创制高点！</h1>
          <!-- <img
            class="foot-wz"
            :src="fileServerUrl + 'assets/images/foot-wz.png'"
          /> -->
          <!--                        <div class="hr-ys">
                            <span >iTall金融洞察力年会2023</span>
                            <hr class="hr-dashed-fixed" style="height: 0.3px"/>
                            <span>iTall银行科技峰会2023</span>
                            <hr class="hr-dashed-fixed" style="height: 0.3px"/>
                            <span>iTall金融科技峰会2023</span>
                            <hr class="hr-dashed-fixed" style="height: 0.3px"/>
                            <span>iTall保险科技峰会2023</span>
                            <hr class="hr-dashed-fixed" style="height: 0.3px"/>
                        </div>-->
        </div>
        <div class="foot-right">
          <div class="foot-right-1">
            <img :src="fileServerUrl + 'assets/images/erwei.jpg'" />
            <span>{{ $t("footer1") }}</span>
            <span>+86 21 6125 8698</span>
            <!-- <span>{{ $t("time") }} 09:00-18:00</span> -->
          </div>
          <div class="foot-right-1">
            <img :src="fileServerUrl + 'assets/images/erwei.jpg'" />
            <span>{{ $t("footer2") }}</span>
            <span>+86 21 6012 6589</span>
            <!-- <span>{{ $t("time") }} 09:00-18:00</span> -->
          </div>
        </div>
      </div>
      <div class="footer-last">
        <div class="fl-child">
          <span> © 2023 HUIYU EXHIBITION (SHANGHAI) CO.,LTD.</span>
          <span>会誉会展（上海）有限公司</span>
          <a
            style="margin-left: 2%"
            target="_blank"
            href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010702007600"
          >
            沪公网安备 31010702007600号
          </a>

          <a href="https://beian.miit.gov.cn/" style="margin-left: 2%"
            >沪ICP备 2020038301号-5</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      fileServerUrl: fileServerUrl,
    };
  },
  methods: {
    getBjtp1(name) {
      let ys = {
        backgroundImage:
          "url(" + this.fileServerUrl + "assets/images/" + name + ")",
        backgroundRepeat: "no-repeat",
        backgroundSize: "100%",
        // height:'57%',
        // backgroundColor:'#524AF6FF',
        backgroundPosition: "center",
      };
      return ys;
    },
  },
};
</script>

<style lang="scss" scoped>
.foot {
  width: 100%;
}

.foot-all {
  font-family: PuHuiTi;
  width: 100%;
  height: 180px;
  position: absolute;
  //font-weight: bold;
  font-size: 0.1rem;
  color: #333333;
}

.foot-left {
  width: 35%;
  height: 80px;
  margin-left: 13.5%;
  padding-bottom: 5px;
  // border: 0.1px solid darkorange;
  margin-top: 4%;
  text-align: center;
  border-radius: 5px;
  backdrop-filter: blur(80px);
  &:hover h1 {
    transform: scale(1.05);
  }
  h1 {
    font-size: 25px;
    color: #ffffff;
    transition: all 0.5s;
  }
}

.hr-ys {
  width: 100%;
  height: 80px;
  margin-top: 3%;
  //border: 0.1px solid red;
}

.foot-right {
  width: 30%;
  margin-top: 5%;
  margin-left: 10%;
  //border: 0.1px solid red;
  height: 105px;
  display: flex;
  justify-content: space-between;
  color: #333333;
}

.foot-right-1 {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: 100px;
  height: 95px;
  //border: 0.1px solid blue;
}
.foot-right-1 img {
  width: 55px;
  height: 55px;
}

.foot-wz {
  width: 220px;
  height: 28px;
  //border: 0.1px solid red;
  margin-left: -6%;
  margin-top: -30%;
}

.footer-last {
  position: absolute;
  width: 100%;
  height: 32px;
  bottom: 0;
  display: flex;
  align-items: center;

  //border: 0.1px solid red;
  //background-color: rgba(245, 13, 13, 0.8);
}

.fl-child {
  display: flex;
  justify-content: center;
  width: 100%;
  font-size: 7px;

  a {
    color: #333333;
  }
}

.hr-dashed-fixed {
  width: 180px;
  border: 0;
  margin-left: -1%;
  padding-top: 0.2px;
  background: repeating-linear-gradient(
    to right,
    red 8px,
    red 12px,
    transparent 12px,
    transparent 14px
  );
}
</style>
